import React, { useContext } from "react";

import "./newResume.css";
import { ThemeContext } from "../../context/ThemeContext";

export default function Blog() {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;
  return (
    // <section id="resume" className="resume">
    //   <div className="section-title">
    //     <h2>Resume</h2>
    //     <p style={{ color: darkMode && "#FFFFFF" }}>
    //       Detail-oriented developer with hands-on experience in building
    //       scalable FullStack web applications using cutting-edge technologies.
    //       Adept at collaborating with cross-functional teams and eager to
    //       contribute to high-impact projects in a dynamic startup environment.
    //     </p>
    //   </div>

    //   <div className="row">
    //     <div className="col-lg-6">
    //       <h3 className="resume-title">Education</h3>
    //       <div className="resume-item">
    //         <h4>Bachelor in Computer Science </h4>
    //         <h5>2022 - 2024</h5>
    //         <p>
    //           <em style={{ color: darkMode && "#FFFFFF" }}>
    //             Wilmington University - New Castle, Delaware
    //           </em>
    //         </p>
    //         <p style={{ color: darkMode && "#FFFFFF" }}>
    //           Outstanding academic achievements, maintained a position on the
    //           dean's list for three consecutive semesters with a remarkable GPA
    //           of 3.97. This reflects my unwavering dedication and commitment to
    //           pursuing excellence consistently.
    //         </p>
    //       </div>
    //       <div className="resume-item">
    //         <h4>
    //           Certificate of Full-Stack Web Development at The Johns Hopkins
    //           School of Engineering
    //         </h4>
    //         <h5>2021 - 2021</h5>
    //         <p style={{ color: darkMode && "#FFFFFF" }}>
    //           <em>John Hopkins University - Baltimore, Maryland</em>
    //         </p>
    //         <p style={{ color: darkMode && "#FFFFFF" }}>
    //           Gained proficiency in various in-demand technologies used in the
    //           field, particularly focusing on the MERN stack. Working
    //           collaboratively with groups, I had the opportunity to apply my
    //           newfound skills in real-world projects. This hands-on experience
    //           not only solidified my understanding of the concepts but also
    //           honed my ability to work effectively within a team environment,
    //           fostering creativity and innovation in problem-solving.
    //         </p>
    //       </div>
    //       <div className="resume-item">
    //         <h4>Associate Degree in Information Technology</h4>
    //         <h5>2017 - 2020</h5>
    //         <p style={{ color: darkMode && "#FFFFFF" }}>
    //           <em>
    //             Community College of Baltimore County Rosedale - Essex, Maryland
    //           </em>
    //         </p>
    //         <p style={{ color: darkMode && "#FFFFFF" }}>
    //           This degree provided me with a solid foundation in various aspects
    //           of technology and fueled my passion to delve deeper into the field
    //           to explore the ever-evolving landscape of IT and Computer Science.
    //         </p>
    //       </div>
    //       <div className="resume-item">
    //         <h4>Major in Physics</h4>
    //         <h5>2013 - 2015</h5>
    //         <p style={{ color: darkMode && "#FFFFFF" }}>
    //           <em>
    //             Pentagon International College (High School) - Kathmandu, Nepal
    //           </em>
    //         </p>
    //         <p style={{ color: darkMode && "#FFFFFF" }}>
    //           Intermediate level Physics provided me with a comprehensive grasp
    //           of the fundamental principles that govern our universe. Cultivated
    //           my analytical thinking and problem-solving skills. I actively
    //           participated in various science and computer-related projects,
    //           where I had the opportunity to apply theoretical knowledge to
    //           practical scenarios.
    //         </p>
    //       </div>
    //     </div>

    <section id="resume" className="resume">
      <div className="section-title">
        <h2>Resume</h2>
        <p style={{ color: darkMode && "#FFFFFF" }}>
          Detail-oriented developer with hands-on experience in building
          scalable FullStack web applications using cutting-edge technologies.
          Adept at collaborating with cross-functional teams and eager to
          contribute to high-impact projects in a dynamic startup environment.
        </p>
      </div>

      <div className="row">
        <div className="col-lg-6">
          <h3 className="resume-title">Education</h3>
          <div className="resume-item">
            <h4>Bachelor in Computer Science</h4>
            <h5>2022 - 2024</h5>
            <p>
              <em style={{ color: darkMode && "#FFFFFF" }}>
                Wilmington University - New Castle, Delaware
              </em>
            </p>
            <p style={{ color: darkMode && "#FFFFFF" }}>
              Outstanding academic achievements, maintained a position on the
              dean's list for three consecutive semesters with a remarkable GPA
              of 3.97. Demonstrates unwavering dedication and commitment to
              pursuing excellence consistently.
            </p>
          </div>
          <div className="resume-item">
            <h4>
              Certificate of Full-Stack Web Development at The Johns Hopkins
              School of Engineering
            </h4>
            <h5>2021 - 2021</h5>
            <p style={{ color: darkMode && "#FFFFFF" }}>
              <em>Johns Hopkins University - Baltimore, Maryland</em>
            </p>
            <p style={{ color: darkMode && "#FFFFFF" }}>
              Proficiency gained in various in-demand technologies, particularly
              focusing on the Full-Stack. Applied newfound skills in real-world
              projects through collaborative group work. This hands-on
              experience solidified understanding of concepts and enhanced the
              ability to work effectively within a team environment, fostering
              creativity and innovation in problem-solving.
            </p>
          </div>
          <div className="resume-item">
            <h4>Associate Degree in Information Technology</h4>
            <h5>2017 - 2020</h5>
            <p style={{ color: darkMode && "#FFFFFF" }}>
              <em>
                Community College of Baltimore County Rosedale - Essex, Maryland
              </em>
            </p>
            <p style={{ color: darkMode && "#FFFFFF" }}>
              This degree provided a solid foundation in various aspects of
              technology and fueled a passion to explore the ever-evolving
              landscape of IT and Computer Science.
            </p>
          </div>
          <div className="resume-item">
            <h4>Major in Physics</h4>
            <h5>2013 - 2015</h5>
            <p style={{ color: darkMode && "#FFFFFF" }}>
              <em>
                Pentagon International College (High School) - Kathmandu, Nepal
              </em>
            </p>
            <p style={{ color: darkMode && "#FFFFFF" }}>
              Intermediate-level Physics provided a comprehensive grasp of the
              fundamental principles governing the universe. Enhanced analytical
              thinking and problem-solving skills, with active participation in
              various science and computer-related projects, applying
              theoretical knowledge to practical scenarios.
            </p>
          </div>
        </div>

        <div className="col-lg-6">
          {/* <h3 className="resume-title">Professional Sumary</h3> */}
          <h3>Skills</h3>

          <div className="resume-item pb-0">
            {/* <h4>Skills</h4> */}
            <h5>Technologies</h5>
            <p style={{ color: darkMode && "#FFFFFF" }}>
              <em>
                HTML, HTML5, CSS, Git, JavaScript, jQuery, Bootstrap, AJAX, Web
                APIs, Third-Party APIs, Server-Side APIs, Node.js,
                Object-Oriented Programming, Media Queries, JSON, React.js,
                Next.js, Progressive Web Applications
              </em>
            </p>
            <h5>Concepts</h5>

            <ul>
              <li>Frontend</li>
              <li>Backend</li>
              <li>SDLC & Agile Development</li>
              <li>UI/UX Development, Wireframing, RESTful API Design</li>
            </ul>
          </div>
          <h3 className="resume-title">
            Real world Full-Stack Projects Experience
          </h3>

          <div className="resume-item">
            <a
              href="https://slicespizzeria.vercel.app"
              target="_blank"
              rel="noopener noreferrer"
            >
              <h4>Food-Ordering App</h4>
            </a>

            <h5>Database - MongoDB</h5>
            <p>
              <em>React & Next.js 14 </em>
            </p>

            <ul>
              <li>
                Repo -{" "}
                <a
                  className="wilmington"
                  href="https://github.com/Rajesh295-dev/pizzaStore"
                >
                  Github
                </a>{" "}
              </li>

              <li>
                Deployed -<a href="https://slicespizzeria.vercel.app"> App</a>
              </li>
              <li>
                Technologies: Node.js, Next.js, Prisma, Zustand, Toastify,
                NextAuth, Stripe, Cloudianry
              </li>
            </ul>
          </div>
          <div className="resume-item">
            <a
              href="https://react-blog-flax.vercel.app"
              target="_blank"
              rel="noopener noreferrer"
            >
              <h4>CMS-Style Blog</h4>
            </a>

            <h5>Database - MongoDB</h5>
            <p>
              <em> Nodejs & React </em>
            </p>
            <ul>
              <li>
                Repo -{" "}
                <a
                  className="wilmington"
                  href="https://github.com/Rajesh295-dev/REACT_blog"
                >
                  Github
                </a>{" "}
              </li>

              <li>
                Deployed -<a href="https://react-blog-flax.vercel.app"> App</a>
              </li>
              <li>
                Technologies: Node.js, Express.js, Sequelize, Mongodb,
                Cloudianry
              </li>
            </ul>
          </div>
          <div className="resume-item">
            <a
              href="https://online-offline-budget-trackers-g0d53tqgt.vercel.app"
              target="_blank"
              rel="noopener noreferrer"
            >
              <h4>PWA-Online-Offline Budget Tracker App</h4>
            </a>

            <h5>Database - MongoDB</h5>
            <p>
              <em>Javascript & Express </em>
            </p>

            <ul>
              <li>
                Repo -{" "}
                <a
                  className="wilmington"
                  href="https://github.com/Rajesh295-dev/budgetTracker"
                >
                  Github
                </a>{" "}
              </li>

              <li>
                Deployed -
                <a href="https://new-budget-tracker.vercel.app"> App</a>
              </li>
              <li>
                Technologies: Node.js, Express.js, Mongoose, Morgan,
                Compression, Sequelize
              </li>
            </ul>
          </div>
          <div className="resume-item">
            <a
              href="https://jhu-project1.github.io/Project1 "
              target="_blank"
              rel="noopener noreferrer"
            >
              <h4> EventFinderApp</h4>
            </a>

            <p>
              <em>Server-side API </em>
            </p>

            <ul>
              <li>
                Repo -{" "}
                <a
                  className="wilmington"
                  href="https://github.com/JHU-Project1/Project1?tab=readme-ov-file"
                >
                  Github
                </a>{" "}
              </li>

              <li>
                Deployed -
                <a href="https://jhu-project1.github.io/Project1 "> App</a>
              </li>
              <li>
                HTML, CSS, Fontaweseome, ULkit, momentJS, javascript, jQuery,
              </li>
            </ul>
          </div>
        </div>
      </div>

      <hr className="borderLine" />
    </section>
  );
}
